import { POPUP_ITEM_DATA_INTER } from '../admin-popup-list/constant';

export const convert = (data: POPUP_ITEM_DATA_INTER) => ({
  ...data,
  status: data.status[0].value,
  lang: data.lang?.[0]?.value,
});
